module.exports = __webpack_public_path__ + "img/hotdog-top-insta-logo.71f344ee.jpg";